import React, { forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import UploadModalContent from './upload-modal/upload-modal';
import CreateReportModalContent from './create-report-modal/create-report-modal';

export const UploadModal = ({ report, item, show, onClose }) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="maker-upload-modal modal-dialog-centered"
  >
    <Modal.Header closeButton>
      <Modal.Title>Upload Document</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <UploadModalContent context={{ report, item }} onClose={onClose} />
    </Modal.Body>
  </Modal>
);

export const CreateReportModal = forwardRef(
  ({ show, onClose, onSubmit, onUploadClick, formData, setFormData }, ref) => (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      dialogClassName="maker-create-report-modal modal-dialog-centered"
      unmountOnExit={false} // Do not unmount when hidden; preserve state.
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Event-Based Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateReportModalContent
          ref={ref}
          onClose={onClose}
          onSubmit={onSubmit}
          onUploadClick={onUploadClick}
          formData={formData}
          setFormData={setFormData}
        />
      </Modal.Body>
    </Modal>
  )
);

export const CommentModal = ({ show, comment, onClose }) => (
  <Modal show={show} onHide={onClose} backdrop="static" dialogClassName="commentModal modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>Report Comment</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{comment || 'No Comments'}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>Close</Button>
    </Modal.Footer>
  </Modal>
);
